"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function appendQueryToUrl(url, query) {
    if (!url) {
        return null;
    }
    if (typeof query !== 'object' || Array.isArray(query)) {
        return url;
    }
    var and = '&';
    // Convert query object into string
    var stringifiedQuery = Object.entries(query).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (value === undefined) {
            return acc;
        }
        var filter = "".concat(key, "=").concat(value);
        return acc.length === 0 ? filter : "".concat(acc).concat(and).concat(filter);
    }, '');
    // Check if the url has an existing query. Return & if it has else return ? if it doesn't.
    var prefix = url.includes('?') ? and : '?';
    return "".concat(url).concat(prefix).concat(stringifiedQuery);
}
exports.default = appendQueryToUrl;
